export type ProductRow = { name: string; percent: number; count: number };

export const PRODUCTS_FIXTURES: ProductRow[] = [
  { name: "Paprika & Onion", percent: 38, count: 162 },
  { name: "Salt & Pepper", percent: 33, count: 81 },
  { name: "Mediterranean", percent: 18, count: 75 },
  { name: "Salt & Vinegar", percent: 12, count: 43 },
];
export const STORE_PREVIEW_IMG =
  "https://images.unsplash.com/photo-1490818387583-1baba5e638af?q=80&w=1200&auto=format&fit=crop";
